<template>

  <div class="hflex">
    <div
      class="hflex-col-0 hflex-options-left"
      :style="{ 'min-width': '240px' }">
      <nav
        class="list-group list-group-flush">
        <router-link
          class="list-group-item list-group-item-action"
          :class="currentRoute === '/billing' ? 'active' : null"
          :to="{ path: '/billing' }">
          {{ $t('Resumo') }}
          </router-link>
        <router-link
          class="list-group-item list-group-item-action"
          :class="currentRoute === '/billing/invoices' ? 'active' : null"
          :to="{ path: '/billing/invoices' }">
          {{ $t('Faturas') }}
          </router-link>
        <router-link
          class="list-group-item list-group-item-action"
          :class="currentRoute === '/billing/details' ? 'active' : null"
          :to="{ path: '/billing/details' }">
          {{ $t('Dados de faturamento') }}
          </router-link>
        <router-link
          class="list-group-item list-group-item-action"
          :class="currentRoute === '/billing/payment' ? 'active' : null"
          :to="{ path: '/billing/payment' }">
          {{ $t('Forma de pagamento') }}
          </router-link>
        <router-link
          class="list-group-item list-group-item-action"
          :class="currentRoute.startsWith('/billing/consumption') ? 'active' : null"
          :to="{ path: '/billing/consumption' }">
          {{ $t('Consumption') }}
          </router-link>
      </nav>
    </div>
    <div class="hflex-col-1">
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
export default {
  name: 'BillingPainel',
  components: {
  },
  data () {
    return {
      creating: true
    }
  },
  computed: {
    currentRoute () {
      return this.$route.path
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingPainel.vue